import React from "react";
import { useTranslation } from "react-i18next";
import Footer from "../../Components/Footer/Footer";
import Nav from "../../Components/Navnew/Nav";
import { companyInfo } from "../../data/company";

const Contact = () => {
  const { t } = useTranslation();

  const formBtn = (e) => {
    e.preventDefault();

    const botMessege = `
Salom ${companyInfo.brandName} Admin, yangi xabar! 😊%0A
Ismi: ${e.target[0].value}%0A
Email: ${e.target[1].value}%0A
`;

    const url = `https://api.telegram.org/bot6373173082:AAFtQIPPcmxBVfYerseJTW524ZhTiKdD1H8/sendMessage?chat_id=-912320303&text=${botMessege}`;

    fetch(url).finally(() => {
      e.target.reset();
    });
  };

  return (
    <>
      <Nav />
      <section className="contact-page">
        <div className="container">
          <div className="contact-shell">
            <div className="contact-card contact-form-card">
              <span className="section-subtitle">{t("contact")}</span>
              <h1 className="section-title contact-title">{t("cus")}</h1>
              <p className="contact-intro">
                {companyInfo.brandName} jamoasi sizga tur, transfer yoki individual
                marshrut bo‘yicha tez javob beradi.
              </p>
              <form onSubmit={formBtn} className="contact-form-grid">
                <div className="form-group">
                  <label htmlFor="name">{t("name")}</label>
                  <input
                    type="text"
                    className="form-control p-3"
                    id="name"
                    placeholder={t("name")}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">{t("email")}</label>
                  <input
                    type="email"
                    className="form-control p-3"
                    id="email"
                    placeholder={t("email")}
                    required
                  />
                </div>
                <div className="mx-auto">
                  <button type="submit" className="submit-button contact-submit">
                    {t("submit")}
                  </button>
                </div>
              </form>
            </div>

            <div className="contact-card contact-info-card">
              <span className="company-pill">{companyInfo.legalType}</span>
              <h2>{companyInfo.legalName}</h2>
              <div className="contact-meta">
                <p>
                  <strong>STIR:</strong> {companyInfo.stir}
                </p>
                <p>
                  <strong>Email:</strong> {companyInfo.email}
                </p>
                <p>
                  <strong>Tel:</strong> {companyInfo.phone}
                </p>
                <p>
                  <strong>Ro‘yxatga olingan sana:</strong>{" "}
                  {companyInfo.registrationDate}
                </p>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </section>
    </>
  );
};

export default Contact;
